<template>
  <div class="report content__area">
    <div class="container-fluid">
      <div class="content__wrapper">
        <div class="row">
          <div class="col-12">
            <div class="content__box">
              <div class="content__box__body">
                <div class="reportsTopbar">
                  <div>
                    <p class="text-white txt--ss opacity--50">Reports</p>
                  </div>
                  <!-- DATE RANGE PICKER -->
                  <div class="dateSlider ml-5">
                    <span class="txt-s opacity--50 cursor-pointer" @click="getPreDateStart()">
                      <i class="fas fa-chevron-left"></i>
                    </span>
                    <!-- <span class="txt--primary txt--ss txt--semi-bold mx-2">April 22 - April 29, 2020</span> -->
                    <VueCtkDateTimePicker
                      class="date__range__input mx-2"
                      v-model="date"
                      :range="true"
                      format="YYYY-MM-DD"
                      formatted="MMM D, YYYY"
                      :no-label="true"
                      :only-date="true"
                      :dark="true"
                      :no-button="true"
                      input-size="sm"
                      :noClearButton="true"
                      :error="false"
                      color="#f5a621"
                      @input="validateRange()"
                      :custom-shortcuts="rangeShortCut"
                    />
                    <span class="txt-s opacity--50 cursor-pointer" @click="getNextDateStart()">
                      <i class="fas fa-chevron-right"></i>
                    </span>
                  </div>
                  <!-- PROPERTY DROPDOWN -->
                  <div class="filterReport mt-3 mt-sm-0 ml-0 ml-sm-5">
                    <p class="txt--ss opacity--25">Filter:</p>
                    <div
                      class="filter__dropdown ml-3"
                      @mouseover="showByDropdown = true"
                      @click.stop="showByDropdown = true"
                    >
                      <span class="txt--ss opacity--50">Property</span>
                      <span
                        v-if="selected_property_name"
                        class="ml-1 txt--primary txt--ss my-3 txt--semi-bold"
                      >{{ selected_property_name }}</span>
                      <div
                        class="filter__items"
                        v-show="showByDropdown"
                        @mouseleave="showByDropdown = false"
                        v-click-outside="closeDropdown"
                      >
                        <div class>
                          <input
                            type="text"
                            placeholder="Find property"
                            aria-label="Search"
                            class="input__field"
                            v-model="searchProperty"
                            @keyup="getAllProperty"
                          />
                          <div class="px-3 mt-3">
                            <div class="top__filter">
                              <ul class="top__filter__ul">
                                <li>Property</li>
                              </ul>
                              <ul class="top__filter__ul">
                                <li class @click="clearPropertyFilter()">Clear filter</li>
                                <!-- <li>None</li> -->
                              </ul>
                            </div>
                            <div class="propertyFilters" v-if="property_list.length > 0">
                              <p
                                class="txt--primary txt--ss my-3 txt--semi-bold"
                                v-for="(p, index) in property_list"
                                :key="index"
                              >
                                <span @click="getAllReportsForSpace(p)">
                                  {{
                                  p.address.split(",")[0]
                                  }}
                                </span>
                              </p>
                            </div>
                            <div class="propertyFilters" v-else>
                              <p class="txt--primary txt--ss my-3 txt--semi-bold">No Property Found</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="exportReport mt-3 mt-sm-0 ml-0 text-right ml-sm-auto">
                    <div class="dropdown property__edit__dropdown">
                      <p
                        class="txt--ss opacity--50 cursor-pointer dropdown-toggle"
                        data-toggle="dropdown"
                      >Export</p>
                      <div
                        class="dropdown-menu dropdown-menu-right"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <!-- <router-link class="dropdown-item mt-0 my-2" to="/report-pdf">Download PDF</router-link> -->
                        <a class="dropdown-item mt-0 my-2" href="javascript:void(0);" @click="getPageData()">Download PDF</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8 mt-4">
            <div class="content__box">
              <div class="content__box__body">
                <div class="row">
                  <div class="col-sm-6 col-md-3 mb-3 mb-md-0 customers-records">
                    <p class="txt--ss opacity--50">Transient Customers</p>
                    <p class="txt--fslg pt-2">{{session_reports.transient_customer}}</p>
                    <p
                      :class="['transient-customers-records txt--ss mt-3', session_reports.transient_customer_inc ? 'txt--green' : 'txt--red']"
                    >
                      <span
                        :class="[session_reports.transient_customer_inc?'txt--green':'txt--red','rounded-circle']"
                      ></span>
                      {{session_reports.transient_customer_inc_value}}%
                    </p>
                  </div>
                  <div class="col-sm-6 col-md-3 mb-3 mb-md-0 customers-records">
                    <p class="txt--ss opacity--50">Permit Customers</p>
                    <p class="txt--fslg pt-2">{{session_reports.monthly_customer}}</p>
                    <p
                      :class="['transient-customers-records txt--ss mt-3',session_reports.monthly_customer_inc ?'txt--green':'txt--red']"
                    >
                      <span
                        :class="[session_reports.monthly_customer_inc ?'txt--green':'txt--red','rounded-circle']"
                      ></span>
                      {{session_reports.monthly_customer_inc_value}}%
                    </p>
                  </div>
                  <div class="col-sm-6 col-md-3 mb-3 mb-md-0 customers-records">
                    <p class="txt--ss opacity--50">Avg. Session Duration</p>
                    <p class="txt--fslg pt-2">{{session_reports.avg_session_duration}}</p>
                    <p
                      :class="['transient-customers-records txt--ss mt-3',session_reports.avg_session_duration_inc ? 'txt--green':'txt--red']"
                    >
                      <span
                        :class="[session_reports.avg_session_duration_inc ?'txt--green':'txt--red','rounded-circle']"
                      ></span>
                      {{session_reports.avg_session_duration_inc_value}}%
                    </p>
                  </div>
                  <div class="col-sm-6 col-md-3 mb-3 mb-md-0 customers-records">
                    <p class="txt--ss opacity--50">Avg. Session Price</p>
                    <p class="txt--fslg pt-2">${{session_reports.avg_session_price}}</p>
                    <p :class="['transient-customers-records txt--ss mt-3',session_reports.avg_session_price_inc ?'txt--green':'txt--red',]">
                      <span
                        :class="[session_reports.avg_session_price_inc ?'txt--green':'txt--red','rounded-circle']"
                      ></span>
                      {{session_reports.avg_session_price_inc_value}}%
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="content__box mt-4">
              <div class="content__box__header">
                <p class="text-white txt--ss opacity--50">Properties</p>
              </div>
              <div class="content__divider"></div>
              <div class="reports__propeties">
                <div class="reports__stats-header">
                  <div class="row">
                    <div class="col-3">
                      <p class="txt--primary txt--xs txt--semi-bold">
                        Property
                        <span class="pl-1">
                          <i class="fas fa-angle-down"></i>
                        </span>
                      </p>
                    </div>
                    <div class="col-1">
                      <p class="txt--xs txt--semi-bold opacity--50">Sessions</p>
                    </div>
                    <div class="col-2">
                      <p class="txt--xs txt--semi-bold opacity--50">Transient Customers</p>
                    </div>
                    <div class="col-2">
                      <p class="txt--xs txt--semi-bold opacity--50">Permit Customers</p>
                    </div>
                    <div class="col-2">
                      <p class="txt--xs txt--semi-bold opacity--50">Occupancy</p>
                    </div>
                    <div class="col-2">
                      <p class="txt--xs txt--semi-bold opacity--50">Earnings</p>
                    </div>
                  </div>
                </div>
                <div class="reports__stats-body">
                  <div class="reports__item">
                    <div class="row reports__padding">
                      <div class="col-3">
                        <p class="txt--primary txt--ss">600 California St</p>
                      </div>
                      <div class="col-1">
                        <p
                          class="property__header__text"
                          :class="{ active: propertyDetails === 'sessions' }"
                          @click="properyViewer('sessions')"
                        >1,656</p>
                      </div>
                      <div class="col-2">
                        <p
                          class="property__header__text"
                          :class="{
                            active: propertyDetails === 'transientCustomers',
                          }"
                          @click="properyViewer('transientCustomers')"
                        >1,600</p>
                      </div>
                      <div class="col-2">
                        <p
                          class="property__header__text"
                          :class="{
                            active: propertyDetails === 'monthlyCustomers',
                          }"
                          @click="properyViewer('monthlyCustomers')"
                        >56</p>
                      </div>
                      <div class="col-2">
                        <p
                          class="property__header__text"
                          :class="{ active: propertyDetails === 'occupancy' }"
                          @click="properyViewer('occupancy')"
                        >91%</p>
                      </div>
                      <div class="col-2">
                        <p
                          class="property__header__text"
                          :class="{ active: propertyDetails === 'earnings' }"
                          @click="properyViewer('earnings')"
                        >$63,921.60</p>
                      </div>
                    </div>
                    <!-- SESSIONS -->
                    <div class="reports__item__content" v-if="propertyDetails === 'sessions'">
                      <div class="content__divider"></div>
                      <div class="reports__details">
                        <div class="row pt-2">
                          <div class="col-5">
                            <p class="txt--primary txt--xs txt--semi-bold">
                              Property
                              <span class="pl-1">
                                <i class="fas fa-angle-up"></i>
                              </span>
                            </p>
                          </div>
                          <div class="col-2">
                            <p class="txt--xs txt--semi-bold opacity--50">Duration</p>
                          </div>
                          <div class="col-2">
                            <p class="txt--xs txt--semi-bold opacity--50">Amount</p>
                          </div>
                          <div class="col-3">
                            <p class="txt--xs txt--semi-bold opacity--50">Vehicle</p>
                          </div>
                        </div>
                        <div class="reports__details--body">
                          <div class="row pt-3">
                            <div class="col-5">
                              <p
                                class="txt--primary txt--xs txt--semi-bold"
                              >Today, July 7, 2020 08:30</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">3 hr 15 mins</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">$26.00</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">7DSD462</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-5">
                              <p
                                class="txt--primary txt--xs txt--semi-bold"
                              >Today, July 7, 2020 08:25</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">2 hr 20 mins</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">$19.20</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">5BRD232</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-5">
                              <p
                                class="txt--primary txt--xs txt--semi-bold"
                              >Today, July 7, 2020 08:20</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">1 hr 25 mins</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">$11.60</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">8YSL188</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-5">
                              <p
                                class="txt--primary txt--xs txt--semi-bold"
                              >Today, July 7, 2020 08:20</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">3 hr 15 mins</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">$26.00</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">3BRZ782</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-5">
                              <p
                                class="txt--primary txt--xs txt--semi-bold"
                              >Today, July 7, 2020 08:25</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">2 hr 20 mins</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">$19.20</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">5BRD232</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-5">
                              <p
                                class="txt--primary txt--xs txt--semi-bold"
                              >Today, July 7, 2020 08:20</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">1 hr 25 mins</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">$11.60</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">8YSL188</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-5">
                              <p
                                class="txt--primary txt--xs txt--semi-bold"
                              >Today, July 7, 2020 08:20</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">3 hr 15 mins</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">$26.00</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">3BRZ782</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-5">
                              <p
                                class="txt--primary txt--xs txt--semi-bold"
                              >Today, July 7, 2020 08:15</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">2 hr 20 mins</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">$19.20</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">5GTT464</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-5">
                              <p
                                class="txt--primary txt--xs txt--semi-bold"
                              >Today, July 7, 2020 08:20</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">3 hr 15 mins</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">$26.00</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">3BRZ782</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="content__divider"></div>
                    </div>
                    <!-- END SESSIONS -->

                    <!-- TRANSIENT CUSTOMER -->
                    <div
                      class="reports__item__content"
                      v-if="propertyDetails === 'transientCustomers'"
                    >
                      <div class="content__divider"></div>
                      <div class="reports__details">
                        <div class="row pt-2">
                          <div class="col-3">
                            <p class="txt--primary txt--xs txt--semi-bold">
                              First Name
                              <span class="pl-1">
                                <i class="fas fa-angle-down"></i>
                              </span>
                            </p>
                          </div>
                          <div class="col-3">
                            <p class="txt--xs txt--semi-bold opacity--50">Last Name</p>
                          </div>
                          <div class="col-1">
                            <p class="txt--xs txt--semi-bold opacity--50">Vehicle</p>
                          </div>
                          <div class="col-2">
                            <p class="txt--xs txt--semi-bold opacity--50">Sessions</p>
                          </div>
                          <div class="col-2">
                            <p class="txt--xs txt--semi-bold opacity--50">Avg. Session Duration</p>
                          </div>
                          <div class="col-1">
                            <p class="txt--xs txt--semi-bold opacity--50">Amount</p>
                          </div>
                        </div>
                        <div class="reports__details--body">
                          <div class="row pt-3">
                            <div class="col-3">
                              <p class="txt--primary txt--xs txt--semi-bold">Alice</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">Matthews</p>
                            </div>
                            <div class="col-1">
                              <p class="txt--xs txt--semi-bold opacity--50">7DSD462</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">3 hr 15 mins</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">3 hr 15 mins</p>
                            </div>
                            <div class="col-1">
                              <p class="txt--xs txt--semi-bold opacity--50">$26.00</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-3">
                              <p class="txt--primary txt--xs txt--semi-bold">Brett</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">Green</p>
                            </div>
                            <div class="col-1">
                              <p class="txt--xs txt--semi-bold opacity--50">5BRD232</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">2 hr 20 mins</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">2 hr 20 mins</p>
                            </div>
                            <div class="col-1">
                              <p class="txt--xs txt--semi-bold opacity--50">$19.20</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-3">
                              <p class="txt--primary txt--xs txt--semi-bold">Chester</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">Ford</p>
                            </div>
                            <div class="col-1">
                              <p class="txt--xs txt--semi-bold opacity--50">8YSL188</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">1 hr 25 mins</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">1 hr 25 mins</p>
                            </div>
                            <div class="col-1">
                              <p class="txt--xs txt--semi-bold opacity--50">$11.60</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-3">
                              <p class="txt--primary txt--xs txt--semi-bold">Franklin</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">Smith</p>
                            </div>
                            <div class="col-1">
                              <p class="txt--xs txt--semi-bold opacity--50">3BRZ782</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">3 hr 15 mins</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">3 hr 15 mins</p>
                            </div>
                            <div class="col-1">
                              <p class="txt--xs txt--semi-bold opacity--50">$26.00</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-3">
                              <p class="txt--primary txt--xs txt--semi-bold">Helena</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">Johnston</p>
                            </div>
                            <div class="col-1">
                              <p class="txt--xs txt--semi-bold opacity--50">5BRD232</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">2 hr 20 mins</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">2 hr 20 mins</p>
                            </div>
                            <div class="col-1">
                              <p class="txt--xs txt--semi-bold opacity--50">$19.20</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="content__divider"></div>
                    </div>
                    <!-- END TRANSIENT CUSTOMER -->

                    <!-- MONTHLY CUSTOMER -->
                    <div
                      class="reports__item__content"
                      v-if="propertyDetails === 'monthlyCustomers'"
                    >
                      <div class="content__divider"></div>
                      <div class="reports__details">
                        <div class="row pt-2">
                          <div class="col-3">
                            <p class="txt--primary txt--xs txt--semi-bold">
                              First Name
                              <span class="pl-1">
                                <i class="fas fa-angle-down"></i>
                              </span>
                            </p>
                          </div>
                          <div class="col-3">
                            <p class="txt--xs txt--semi-bold opacity--50">Last Name</p>
                          </div>
                          <div class="col-2">
                            <p class="txt--xs txt--semi-bold opacity--50">Vehicle</p>
                          </div>
                        </div>
                        <div class="reports__details--body">
                          <div class="row pt-3">
                            <div class="col-3">
                              <p class="txt--primary txt--xs txt--semi-bold">Alice</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">Matthews</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">7DSD462</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-3">
                              <p class="txt--primary txt--xs txt--semi-bold">Brett</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">Green</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">5BRD232</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-3">
                              <p class="txt--primary txt--xs txt--semi-bold">Chester</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">Ford</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">8YSL188</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-3">
                              <p class="txt--primary txt--xs txt--semi-bold">Franklin</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">Smith</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">3BRZ782</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-3">
                              <p class="txt--primary txt--xs txt--semi-bold">Helena</p>
                            </div>
                            <div class="col-3">
                              <p class="txt--xs txt--semi-bold opacity--50">Johnston</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">5BRD232</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="content__divider"></div>
                    </div>
                    <!-- END MONTHLY CUSTOMER -->

                    <!-- occupancy -->
                    <div class="reports__item__content" v-if="propertyDetails === 'occupancy'">
                      <div class="content__divider"></div>
                      <div class="reports__details">
                        <div class="row pt-2">
                          <div class="col-4">
                            <p class="txt--primary txt--xs txt--semi-bold">
                              Date
                              <span class="pl-1">
                                <i class="fas fa-angle-down"></i>
                              </span>
                            </p>
                          </div>
                          <div class="col-3">
                            <p class="txt--xs txt--semi-bold opacity--50">occupancy</p>
                          </div>
                        </div>
                        <div class="reports__details--body">
                          <div class="row pt-3">
                            <div class="col-4">
                              <p class="txt--primary txt--xs txt--semi-bold">Sunday, July 5, 2020</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">60%</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-4">
                              <p class="txt--primary txt--xs txt--semi-bold">Monday, July 6, 2020</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">93%</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-4">
                              <p class="txt--primary txt--xs txt--semi-bold">Tuesday, July 7, 2020</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">98%</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="content__divider"></div>
                    </div>
                    <!-- END occupancy -->

                    <!-- EARNINGS -->
                    <div class="reports__item__content" v-if="propertyDetails === 'earnings'">
                      <div class="content__divider"></div>
                      <div class="reports__details">
                        <div class="row pt-2">
                          <div class="col-4">
                            <p class="txt--xs opacity--50 txt--semi-bold">Type</p>
                          </div>
                          <div class="col-3">
                            <p class="txt--xs txt--semi-bold opacity--50">Earnings</p>
                          </div>
                        </div>
                        <div class="reports__details--body">
                          <div class="row pt-3">
                            <div class="col-4">
                              <p class="txt--ss">Transient Customers</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--ss">$24,471.90</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-4">
                              <p class="txt--ss">Early Bird</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--ss">$17,845.20</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-4">
                              <p class="txt--ss">Special Event</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--ss">$8,953.50</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-4">
                              <p class="txt--ss">Permit Customers</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--ss">$12,650.00</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="content__divider"></div>
                    </div>
                    <!-- END EARNINGS -->
                  </div>
                  <div class="reports__item">
                    <div class="row reports__padding">
                      <div class="col-3">
                        <p class="txt--primary property__header__text">601 Van Ness Ave</p>
                      </div>
                      <div class="col-1">
                        <p class="property__header__text">1,537</p>
                      </div>
                      <div class="col-2">
                        <p class="property__header__text">1,489</p>
                      </div>
                      <div class="col-2">
                        <p class="property__header__text">48</p>
                      </div>
                      <div class="col-2">
                        <p class="property__header__text">87%</p>
                      </div>
                      <div class="col-2">
                        <p class="property__header__text">$59,328.20</p>
                      </div>
                    </div>
                  </div>
                  <div class="reports__item">
                    <div class="row reports__padding">
                      <div class="col-3">
                        <p class="txt--primary property__header__text">750 O’Farrell St</p>
                      </div>
                      <div class="col-1">
                        <p class="property__header__text">2,070</p>
                      </div>
                      <div class="col-2">
                        <p class="property__header__text">2,008</p>
                      </div>
                      <div class="col-2">
                        <p class="property__header__text">62</p>
                      </div>
                      <div class="col-2">
                        <p class="property__header__text">82%</p>
                      </div>
                      <div class="col-2">
                        <p class="property__header__text">$79,902.00</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 mt-4">
            <div class="graph__area">
              <!-- SESSION & EARNING REPORT -->
              <div class="content__box content__box--graph h-50">
                <div class="content__box__header">
                  <div class="top__filter">
                    <ul class="top__filter__ul">
                      <li
                        :class="[earning == 1?'active' : '']"
                        @click="changeSessionEarningReport(1)"
                      >Sessions</li>
                      <li
                        :class="[earning == 2?'active' : '']"
                        @click="changeSessionEarningReport(2)"
                      >Earnings</li>
                    </ul>
                  </div>
                  <h2 class="primaryHeader">{{ session_total }}</h2>
                  <p
                    :class="[
                      'transient-customers-records txt--ss mt-3',
                      session_inc ? ' txt--green' : 'txt--red',
                    ]"
                  >
                    <span
                      :class="[
                        session_inc ? 'txt--green' : 'txt--red',
                        'rounded-circle',
                      ]"
                    ></span>
                    {{ session_inc_value }}%
                  </p>
                </div>
                <div class="content__box__body responsive__height pt-0">
                  <!-- Put chart here -->
                  <Chart :data="session_chart" :chart_type="earning" />
                </div>
              </div>
              <!-- OCCUPANCY REPORT -->
              <div class="content__box content__box--graph h-50 mt-4">
                <div class="content__box__header">
                  <div class="top__filter">
                    <ul class="top__filter__ul">
                      <li>Occupancy</li>
                    </ul>
                  </div>
                  <h2 class="primaryHeader">{{occupancy_total}}%</h2>
                  <p
                    :class="['transient-customers-records txt--ss mt-3',occupancy_inc ? 'txt--green' : 'txt--red']"
                  >
                    <span :class="[occupancy_inc ? 'txt--green' : 'txt--red','rounded-circle']"></span>
                    {{occupancy_inc_percentage}}%
                  </p>
                </div>
                <div class="content__box__body responsive__height pt-0">
                  <!-- Put chart here -->
                  <Occupancy :data="occupancy_chart" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import SessionChart from "@/components/sessionChart";
import Chart from "@/components/ChartDrill";
// import reportOccupancyChart from "@/components/reportOccupancyChart";
import Occupancy from "@/components/ChartOccupancy";
import commonservices from "../../services/CommonService";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

const service = new commonservices();

export default {
  name: "Report",
  components: {
    // SessionChart,
    Chart: Chart,
    Occupancy: Occupancy,
    VueCtkDateTimePicker: VueCtkDateTimePicker
  },
  data() {
    return {
      showByDropdown: false,
      propertyDetails: null,
      property_list: [],
      space_id: null,
      selected_property_name: null,
      searchProperty: "",
      range_err: false,
      rangeShortCut: [],
      date_range_type: "week",
      date: {
        start: this.$moment()
          .startOf("week")
          .format("YYYY-MM-DD"),
        end: this.$moment()
          .endOf("week")
          .format("YYYY-MM-DD")
      },
      // AVG SESSION DURATION & AMOUNT, MONTHLY CUSTOMERS
      session_reports: {
        monthly_customer: 0,
        monthly_customer_inc: true,
        monthly_customer_inc_value: "+" + 0,
        avg_session_duration: 0,
        avg_session_duration_inc: true,
        avg_session_duration_inc_value: "+" + 0,
        avg_session_price: 0,
        avg_session_price_inc: true,
        avg_session_price_inc_value: "+" + 0,
        transient_customer: 5097,
        transient_customer_inc: true,
        transient_customer_inc_value: "+" + 33.45
      },
      // session / earning chart
      earning: 1,
      session_chart: [],
      session_total: 0,
      session_inc: true,
      session_inc_value: "+0.00",
      chart_type: "week",
      // Occupancy chart
      occupancy_chart_report_type: "week",
      occupancy_chart: [],
      occupancy_total: 0.0,
      occupancy_inc: true,
      occupancy_inc_percentage: "+0.00"
    };
  },
  directives: {
    "click-outside": {
      bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = e => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
        console.log(binding);
      }
    }
  },
  created() {
    this.getAllProperty();
    this.getAllReports();

    //===== Get ShortCut Range =====//
    // This week
    this.rangeShortCut.push({
      key: "thisWeek",
      label: "This Week",
      value: () => {
        return {
          start: this.$moment().startOf("week"),
          end: this.$moment().endOf("week")
        };
      },
      callback: ({ start, end }) => {
        this.date_range_type = "week";
        console.log(
          "This week selected : ",
          start.format("YYYY-MM-DD"),
          end.format("YYYY-MM-DD")
        );
      }
    });
    // Last week
    this.rangeShortCut.push({
      key: "lastWeek",
      label: "Last Week",
      value: () => {
        return {
          start: this.$moment()
            .add(-7, "days")
            .startOf("week"),
          end: this.$moment()
            .add(-7, "days")
            .endOf("week")
        };
      },
      callback: ({ start, end }) => {
        this.date_range_type = "week";
        console.log(
          "Last week selected : ",
          start.format("YYYY-MM-DD"),
          end.format("YYYY-MM-DD")
        );
      }
    });
    // This Month
    this.rangeShortCut.push({
      key: "thisMonth",
      label: "This Month",
      value: () => {
        return {
          start: this.$moment().startOf("month"),
          end: this.$moment().endOf("month")
        };
      },
      callback: ({ start, end }) => {
        this.date_range_type = "day";
        console.log(
          "This Month Selected : ",
          start.format("YYYY-MM-DD"),
          end.format("YYYY-MM-DD")
        );
      }
    });
    // Last Month
    this.rangeShortCut.push({
      key: "lastMonth",
      label: "Last Month",
      value: () => {
        return {
          start: this.$moment()
            .add(-1, "months")
            .startOf("month"),
          end: this.$moment()
            .add(-1, "months")
            .endOf("month")
        };
      },
      callback: ({ start, end }) => {
        this.date_range_type = "day";
        console.log(
          "Last Month Selected : ",
          start.format("YYYY-MM-DD"),
          end.format("YYYY-MM-DD")
        );
      }
    });
    // This Year
    this.rangeShortCut.push({
      key: "thisYear",
      label: "This Year",
      value: () => {
        return {
          start: this.$moment().startOf("year"),
          end: this.$moment().endOf("month")
        };
      },
      callback: ({ start, end }) => {
        this.date_range_type = "month";
        console.log(
          "This year Selected : ",
          start.format("YYYY-MM-DD"),
          end.format("YYYY-MM-DD")
        );
      }
    });
    // Last year
    this.rangeShortCut.push({
      key: "lastYear",
      label: "Last Year",
      value: () => {
        return {
          start: this.$moment()
            .add(-1, "years")
            .startOf("year"),
          end: this.$moment()
            .add(-1, "years")
            .endOf("year")
        };
      },
      callback: ({ start, end }) => {
        this.date_range_type = "month";
        console.log(
          "This year Selected : ",
          start.format("YYYY-MM-DD"),
          end.format("YYYY-MM-DD")
        );
      }
    });
  },
  methods: {
    closeDropdown() {
      this.showByDropdown = false;
    },
    properyViewer(property) {
      this.propertyDetails = property;
    },
    async getAllProperty() {
      let property_response = await service.getAllProperty(this.searchProperty);
      if (property_response.status == 200) {
        if (property_response.data.status) {
          this.property_list = property_response.data.data.all_space;
        } else {
          this.property_list = [];
        }
      } else {
        this.$toasted.show("Something went wrong. Please try again!", {
          icon: "timex-circle",
          className: "error-class"
        });
      }
    },
    clearPropertyFilter() {
      this.space_id = null;
      this.selected_property_name = null;
      this.getAllReports();
    },
    getAllReportsForSpace(space) {
      this.space_id = space.space_id;
      this.selected_property_name = space.address.split(",")[0];
      this.getAllReports();
    },
    validateRange() {
      this.$nextTick(() => {
        console.log(this.date_range_type);

        if (this.date_range_type == "week") {
          let end_wk = this.$moment(this.date.start, "YYYY-MM-DD")
            .add(6, "days")
            .format("YYYY-MM-DD");
          if (this.date.end != null && end_wk !== this.date.end) {
            this.range_err = true;
            this.date.end = null;
            this.$toasted.show("Only week range can be selected!", {
              icon: "times-circle",
              className: "error-class"
            });
          } else {
            this.range_err = false;
            if (this.date.end != null && this.date.start != null) {
              this.getAllReports();
            }
          }
        } else if (this.date_range_type == "day") {
          let end_month = this.$moment(this.date.start)
            .endOf("month")
            .format("YYYY-MM-DD");
          let start_month = this.$moment(this.date.start)
            .startOf("month")
            .format("YYYY-MM-DD");
          if (this.date.start != null && this.date.start !== start_month) {
            this.range_err = true;
            this.date.start = null;
            this.$toasted.show("Only month range can be selected!", {
              icon: "times-circle",
              className: "error-class"
            });
            return false;
          }
          if (this.date.end != null && end_month !== this.date.end) {
            this.range_err = true;
            this.date.end = null;
            this.$toasted.show("Only month range can be selected!", {
              icon: "times-circle",
              className: "error-class"
            });
          } else {
            this.range_err = false;
            if (this.date.end != null && this.date.start != null) {
              this.getAllReports();
            }
          }
        } else if (this.date_range_type == "month") {
          console.log(this.date.start, this.date.end);
          let month_start = this.$moment(this.date.start)
            .startOf("month")
            .format("YYYY-MM-DD");
          let month_end = this.$moment(this.date.end)
            .endOf("month")
            .format("YYYY-MM-DD");
          if (this.date.start != month_start) {
            this.$toasted.show("Can only select month range!", {
              icon: "times-circle",
              className: "error-class"
            });
            this.date.start = null;
            this.date.end = null;
            return false;
          }
          if (this.date.end != null && this.date.end != month_end) {
            this.$toasted.show("Can only select month range!", {
              icon: "times-circle",
              className: "error-class"
            });
            this.date.start = null;
            this.date.end = null;
            return false;
          }
          if (
            this.date.end != null &&
            this.$moment(this.date.start).format("YYYY") !==
              this.$moment(this.date.end).format("YYYY")
          ) {
            this.$toasted.show("Range must be of the same year!", {
              icon: "times-circle",
              className: "error-class"
            });
            this.date.start = null;
            this.date.end = null;
            return false;
          }
          if (this.date.start != null && this.date.end != null) {
            this.getAllReports();
          }
        } else {
          this.$toasted.show("Something went wrong. Please try again!", {
            icon: "times-circle",
            className: "error-class"
          });
        }
      });
    },
    getPreDateStart() {
      if (this.date.start == null) {
        this.$toasted.show("Please select a range!", {
          icon: "times-circle",
          className: "error-class"
        });
        return;
      }
      if (this.date_range_type == "week") {
        this.date.end = this.$moment(this.date.start)
          .add(-1, "days")
          .format("YYYY-MM-DD");
        this.date.start = this.$moment(this.date.end)
          .add(-6, "days")
          .format("YYYY-MM-DD");
      } else if (this.date_range_type == "day") {
        this.date.end = this.$moment(this.date.start)
          .add(-1, "days")
          .format("YYYY-MM-DD");
        this.date.start = this.$moment(this.date.end)
          .startOf("month")
          .format("YYYY-MM-DD");
      } else if (this.date_range_type == "month") {
        this.date.end = this.$moment(this.date.start)
          .add(-1, "days")
          .format("YYYY-MM-DD");
        this.date.start = this.$moment(this.date.end)
          .startOf("year")
          .format("YYYY-MM-DD");
      }

      this.getAllReports();
    },
    getNextDateStart() {
      if (this.date.end == null) {
        this.$toasted.show("Please select a range!", {
          icon: "times-circle",
          className: "error-class"
        });
        return;
      }
      if (this.date_range_type == "week") {
        this.date.start = this.$moment(this.date.end)
          .add(1, "days")
          .format("YYYY-MM-DD");
        this.date.end = this.$moment(this.date.start)
          .add(6, "days")
          .format("YYYY-MM-DD");
      } else if (this.date_range_type == "day") {
        this.date.start = this.$moment(this.date.end)
          .add(1, "days")
          .format("YYYY-MM-DD");
        this.date.end = this.$moment(this.date.start)
          .endOf("month")
          .format("YYYY-MM-DD");
      } else if (this.date_range_type == "month") {
        this.date.start = this.$moment(this.date.end)
          .add(1, "days")
          .format("YYYY-MM-DD");
        this.date.end = this.$moment(this.date.start)
          .endOf("year")
          .format("YYYY-MM-DD");
      }

      this.getAllReports();
    },
    async getAllReports() {
      this.chart_type = this.date_range_type;
      this.occupancy_chart_report_type = this.date_range_type;
      if (this.earning == 1) {
        //===================== Get Session Chart ==============//
        await this.getSessionChartData();
      } else {
        //====================== Get Earning Chart =============//
        await this.getEarningChartData();
      }
      //======================== Get Occupancy Chart ================//
      await this.getCurrentOccupancyChart();
      //===================== Get Monthly customer , avg session duration , avg session price ====================//
      this.getAvgSessionMonthlyCustomer();
    },
    changeSessionEarningReport(type) {
      this.earning = type;
      if (this.earning == 1) {
        this.getSessionChartData();
      } else {
        this.getEarningChartData();
      }
    },
    //================== API FOR SESSION CHART =========//
    getSessionChartData() {
      let from = null;
      let to = null;
      if (this.chart_type == "hour") {
        this.session_chart_from = this.$moment().format("YYYY-MM-DD");
        this.session_chart_to = this.$moment().format("YYYY-MM-DD");
      } else if (this.chart_type == "day") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.chart_type == "week") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.chart_type == "month") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.chart_type == "year") {
        from = "2018-01-01";
        to = this.date.end;
      } else {
        this.$toasted.show("Something went wrong. Please try again!", {
          icon: "times-circle",
          className: "error-class"
        });
        return false;
      }

      this.axios
        .post(window.hostname + "api/auth/session-report", {
          time_zone: this.$moment.tz.guess(new Date()),
          from: from,
          to: to,
          commercial: 1,
          report_type: this.chart_type,
          space_id: this.space_id
        })
        .then(res => {
          if (res.data.status) {
            this.session_chart = res.data.data.report_data;
            this.session_total = parseInt(res.data.data.total);
            if (
              this.chart_type == "hour" ||
              this.chart_type == "week" ||
              this.chart_type == "day"
            ) {
              if (
                parseFloat(res.data.data.total) >=
                parseFloat(res.data.data.total_prev)
              ) {
                this.session_inc = true;
                if (
                  parseFloat(res.data.data.total) ==
                  parseFloat(res.data.data.total_prev)
                ) {
                  this.session_inc_value = "+0.00";
                } else if (
                  parseFloat(res.data.data.total) != 0 &&
                  parseFloat(res.data.data.total_prev) == 0
                ) {
                  this.session_inc_value = "+100.00";
                } else {
                  this.session_inc_value =
                    "+" +
                    (
                      (parseFloat(res.data.data.total) -
                        parseFloat(res.data.data.total_prev)) /
                      parseFloat(res.data.data.total_prev)
                    ).toFixed(2) *
                      100;
                }
              } else {
                this.session_inc = false;
                if (
                  parseFloat(res.data.data.total) == 0 &&
                  parseFloat(res.data.data.total_prev) != 0
                ) {
                  this.session_inc_value = "-100.00";
                } else {
                  this.session_inc_value =
                    "-" +
                    (
                      (parseFloat(res.data.data.total_prev) -
                        parseFloat(res.data.data.total)) /
                      parseFloat(res.data.data.total_prev)
                    ).toFixed(2) *
                      100;
                }
              }
            } else {
              let length = this.session_chart.length - 1;
              let last_value = parseInt(this.session_chart[length].y);
              let prev_value = parseInt(res.data.data.total_prev);
              if (last_value >= prev_value) {
                this.session_inc = true;
                if (prev_value == 0 && last_value != 0) {
                  this.session_inc_value = "+100.00";
                } else if (prev_value == last_value) {
                  this.session_inc_value = "+0.00";
                } else {
                  this.session_inc_value =
                    "+" +
                    ((last_value - prev_value) / prev_value).toFixed(2) * 100;
                }
              } else {
                this.session_inc = false;
                if (prev_value != 0 && last_value == 0) {
                  this.session_inc_value = "-100.00";
                } else {
                  this.session_inc_value =
                    "-" +
                    ((prev_value - last_value) / prev_value).toFixed(2) * 100;
                }
              }
            }
          } else {
            this.$toasted.show("Something went wrong. Please try again!", {
              icon: "times-circle",
              className: "error-class"
            });
          }
        });
    },
    //================= API FOR EARNING CHART =============//
    async getEarningChartData() {
      let from = null;
      let to = null;
      if (this.chart_type == "hour") {
        this.session_chart_from = this.$moment().format("YYYY-MM-DD");
        this.session_chart_to = this.$moment().format("YYYY-MM-DD");
      } else if (this.chart_type == "day") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.chart_type == "week") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.chart_type == "month") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.chart_type == "year") {
        from = "2018-01-01";
        to = this.date.end;
      } else {
        this.$toasted.show("Something went wrong. Please try again!", {
          icon: "times-circle",
          className: "error-class"
        });
        return false;
      }

      await this.axios
        .post(window.hostname + "api/auth/earning-report", {
          time_zone: this.$moment.tz.guess(new Date()),
          from: from,
          to: to,
          commercial: 1,
          report_type: this.chart_type,
          space_id: this.space_id
        })
        .then(res => {
          if (res.data.status) {
            this.session_chart = res.data.data.report_data;
            this.session_total = parseInt(res.data.data.total);
            if (
              this.chart_type == "hour" ||
              this.chart_type == "week" ||
              this.chart_type == "day"
            ) {
              if (
                parseFloat(res.data.data.total) >=
                parseFloat(res.data.data.total_prev)
              ) {
                this.session_inc = true;
                if (
                  parseFloat(res.data.data.total) ==
                  parseFloat(res.data.data.total_prev)
                ) {
                  this.session_inc_value = "+0.00";
                } else if (
                  parseFloat(res.data.data.total) != 0 &&
                  parseFloat(res.data.data.total_prev) == 0
                ) {
                  this.session_inc_value = "+100.00";
                } else {
                  this.session_inc_value =
                    "+" +
                    (
                      (parseFloat(res.data.data.total) -
                        parseFloat(res.data.data.total_prev)) /
                      parseFloat(res.data.data.total_prev)
                    ).toFixed(2) *
                      100;
                }
              } else {
                this.session_inc = false;
                if (
                  parseFloat(res.data.data.total) == 0 &&
                  parseFloat(res.data.data.total_prev) != 0
                ) {
                  this.session_inc_value = "-100.00";
                } else {
                  this.session_inc_value =
                    "-" +
                    (
                      (parseFloat(res.data.data.total_prev) -
                        parseFloat(res.data.data.total)) /
                      parseFloat(res.data.data.total_prev)
                    ).toFixed(2) *
                      100;
                }
              }
            } else {
              let length = this.session_chart.length - 1;
              let last_value = parseInt(this.session_chart[length].y);
              let prev_value = parseInt(res.data.data.total_prev);
              if (last_value >= prev_value) {
                this.session_inc = true;
                if (prev_value == 0 && last_value != 0) {
                  this.session_inc_value = "+100.00";
                } else if (prev_value == last_value) {
                  this.session_inc_value = "+0.00";
                } else {
                  this.session_inc_value =
                    "+" +
                    ((last_value - prev_value) / prev_value).toFixed(2) * 100;
                }
              } else {
                this.session_inc = false;
                if (prev_value != 0 && last_value == 0) {
                  this.session_inc_value = "-100.00";
                } else {
                  this.session_inc_value =
                    "-" +
                    ((prev_value - last_value) / prev_value).toFixed(2) * 100;
                }
              }
            }
          } else {
            this.$toasted.show("Something went wrong. Please try again!", {
              icon: "times-circle",
              className: "error-class"
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.$toasted.show("Something went wrong. Please try again!", {
            icon: "times-circle",
            className: "error-class"
          });
        });
    },
    //=============== API FOR CURRENT OCCUPANCY CHART DATA ================//
    async getCurrentOccupancyChart() {
      let from = null;
      let to = null;
      if (this.occupancy_chart_report_type == "hour") {
        this.session_chart_from = this.$moment().format("YYYY-MM-DD");
        this.session_chart_to = this.$moment().format("YYYY-MM-DD");
      } else if (this.occupancy_chart_report_type == "day") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.occupancy_chart_report_type == "week") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.occupancy_chart_report_type == "month") {
        from = this.$moment(this.date.start)
          .startOf("year")
          .format("YYYY-MM-DD");
        to = this.date.end;
      } else if (this.occupancy_chart_report_type == "year") {
        from = "2018-01-01";
        to = this.date.end;
      } else {
        this.$toasted.show("Something went wrong. Please try again!", {
          icon: "times-circle",
          className: "error-class"
        });
        return false;
      }

      await this.axios
        .post(window.hostname + "api/auth/occupancy-report", {
          space_id: this.space_id,
          report_type: this.occupancy_chart_report_type,
          from: from,
          to: to,
          commercial: 1,
          time_zone: this.$moment.tz.guess(new Date())
        })
        .then(res => {
          if (res.data.status) {
            this.occupancy_chart = res.data.data.report_data;
            this.occupancy_total = res.data.data.total;
            this.getPastOccupancyReport();
          } else {
            this.$toasted.show("Something went wrong. Please try again!", {
              icon: "times-circle",
              className: "error-class"
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.$toasted.show("Something went wrong. Please try again!", {
            icon: "times-circle",
            className: "error-class"
          });
        });
    },
    //=============== API FOR PAST OCCUPANCY CHART DATA
    getPastOccupancyReport() {
      let past_from = "";
      let past_to = "";
      if (this.occupancy_chart_report_type == "hour") {
        past_from = this.$moment(this.date.start)
          .add(-1, "days")
          .format("YYYY-MM-DD");
        past_to = this.$moment(this.date.end)
          .add(-1, "days")
          .format("YYYY-MM-DD");
      } else if (this.occupancy_chart_report_type == "day") {
        past_to = this.$moment(this.date.start)
          .add(-1, "days")
          .format("YYYY-MM-DD");
        past_from = this.$moment(past_to)
          .startOf("month")
          .format("YYYY-MM-DD");
      } else if (this.occupancy_chart_report_type == "week") {
        past_to = this.$moment(this.date.start)
          .add(-1, "days")
          .format("YYYY-MM-DD");
        past_from = this.$moment(this.date.start)
          .add(-7, "days")
          .format("YYYY-MM-DD");
      } else if (this.occupancy_chart_report_type == "month") {
        past_from = this.$moment(this.date.start)
          .startOf("year")
          .format("YYYY-MM-DD");
        past_to = this.$moment(this.date.end)
          .add(-1, "months")
          .format("YYYY-MM-DD");
      } else if (this.occupancy_chart_report_type == "year") {
        past_from = "2018-01-01";
        past_to = this.$moment(this.date.end)
          .add(-1, "years")
          .format("YYYY-MM-DD");
      } else {
        this.$toasted.show("Something went wrong. Please try again!", {
          icon: "times-circle",
          className: "error-class"
        });
        return false;
      }
      // console.log(past_from , past_to);
      this.axios
        .post(window.hostname + "api/auth/occupancy-report", {
          space_id: this.space_id,
          report_type: this.occupancy_chart_report_type,
          from: past_from,
          to: past_to,
          commercial: 1,
          time_zone: this.$moment.tz.guess(new Date())
        })
        .then(res => {
          if (res.data.status) {
            let past_total = res.data.data.total;
            if (this.occupancy_total >= past_total) {
              this.occupancy_inc = true;
              if (this.occupancy_total == past_total) {
                this.occupancy_inc_percentage = "+0.00";
              } else if (this.occupancy_total != 0 && past_total == 0) {
                this.occupancy_inc_percentage = "+100.00";
              } else {
                this.occupancy_inc_percentage =
                  "+" +
                  (
                    ((this.occupancy_total - past_total) / past_total) *
                    100
                  ).toFixed(2);
              }
            } else {
              this.occupancy_inc = false;
              if (this.occupancy_total == 0 && past_total != 0) {
                this.occupancy_inc_percentage = "-0.00";
              } else {
                this.occupancy_inc_percentage =
                  "-" +
                  (
                    ((past_total - this.occupancy_total) / past_total) *
                    100
                  ).toFixed(2);
              }
            }
          } else {
            this.$toasted.show("Something went wrong. Please try again!", {
              icon: "times-circle",
              className: "error-class"
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.$toasted.show("Something went wrong. Please try again!", {
            icon: "times-circle",
            className: "error-class"
          });
        });
    },
    //================ API FOR MONTHLY CUSTOMER, AVG SESSION DURATION, AVG SESSION PRICE =================//
    getAvgSessionMonthlyCustomer() {
      this.axios
        .post(window.hostname + "/api/auth/transient-report", {
          device_type: 1,
          commercial: 1,
          space_id: this.space_id,
          from : this.date.start ,
          to : this.date.end,
          report_type : this.date_range_type,
          time_zone : this.$moment.tz.guess()
        })
        .then(res => {
          if (res.data.status) {
            this.session_reports.monthly_customer =
              res.data.data.current_month_user_count;
            this.session_reports.avg_session_price =
              res.data.data.avg_session_price;
            this.session_reports.avg_session_duration =
              res.data.data.avg_session_duration;
            // monthly customer percentage calculation
            if (
              res.data.data.current_month_user_count >=
              res.data.data.last_month_user_count
            ) {
              this.session_reports.monthly_customer_inc = true;

              if (
                res.data.data.last_month_user_count == 0 &&
                res.data.data.current_month_user_count == 0
              ) {
                this.session_reports.monthly_customer_inc_value = "+0.00";
              } else if (
                res.data.data.last_month_user_count == 0 &&
                res.data.data.current_month_user_count != 0
              ) {
                this.session_reports.monthly_customer_inc_value = "+100.00";
              } else if (
                res.data.data.last_month_user_count ==
                res.data.data.current_month_user_count
              ) {
                this.session_reports.monthly_customer_inc_value = "+0.00";
              } else {
                this.session_reports.monthly_customer_inc_value =
                  "+" +
                  ((
                    (res.data.data.current_month_user_count -
                      res.data.data.last_month_user_count) /
                    res.data.data.last_month_user_count
                  ) *100).toFixed(2);
              }
            } else {
              this.session_reports.monthly_customer_inc = false;

              if (
                res.data.data.current_month_user_count == 0 &&
                res.data.data.last_month_user_count != 0
              ) {
                this.session_reports.monthly_customer_inc_value = "-100.00";
              } else {
                this.session_reports.monthly_customer_inc_value ="-"+
                  ((
                    (res.data.data.last_month_user_count -
                      res.data.data.current_month_user_count) /
                    res.data.data.last_month_user_count
                  )* 100).toFixed(2) ;
              }
            }

            // avg session price percentage calculation
            if (
              parseFloat(res.data.data.avg_session_price) >=
              parseFloat(res.data.data.avg_session_price_old)
            ) {
              this.session_reports.avg_session_price_inc = true;
              if (
                parseFloat(res.data.data.avg_session_price) ==
                parseFloat(res.data.data.avg_session_price_old)
              ) {
                this.session_reports.avg_session_price_inc_value = "+0.00";
              } else if (
                parseFloat(res.data.data.avg_session_price) != 0 &&
                parseFloat(res.data.data.avg_session_price_old) == 0
              ) {
                this.session_reports.avg_session_price_inc_value = "+100.00";
              } else {
                this.session_reports.avg_session_price_inc_value =
                  "+" +
                  ((
                    (parseFloat(res.data.data.avg_session_price) -
                      parseFloat(res.data.data.avg_session_price_old)) /
                    parseFloat(res.data.data.avg_session_price_old)
                  )*100).toFixed(2) ;
              }
            } else {
              this.session_reports.avg_session_price_inc = false;
              if (
                parseFloat(res.data.data.avg_session_price) == 0 &&
                parseFloat(res.data.data.avg_session_price_old) != 0
              ) {
                this.session_reports.avg_session_price_inc_value = "-100.00";
              } else {
                this.session_reports.avg_session_price_inc_value ="-"+
                  ((
                    (parseFloat(res.data.data.avg_session_price_old) -
                      parseFloat(res.data.data.avg_session_price)) /
                    parseFloat(res.data.data.avg_session_price_old)
                  )*100).toFixed(2);
              }
            }

            //avg session duration percentage calculation
            if (
              res.data.data.avg_session_duration_seconds >=
              res.data.data.avg_session_duration_seconds_past
            ) {
              this.session_reports.avg_session_duration_inc = true;
              if (
                res.data.data.avg_session_duration_seconds ==
                res.data.data.avg_session_duration_seconds_past
              ) {
                this.session_reports.avg_session_duration_inc_value = "+0.00";
              } else if (
                res.data.data.avg_session_duration_seconds != 0 &&
                res.data.data.avg_session_duration_seconds_past == 0
              ) {
                this.session_reports.avg_session_duration_inc_value = "+100.00";
              } else {
                this.session_reports.avg_session_duration_inc_value =
                  "+" +
                  ((
                    (res.data.data.avg_session_duration_seconds -
                      res.data.data.avg_session_duration_seconds_past) /
                    res.data.data.avg_session_duration_seconds_past
                  )*100).toFixed(2) ;
              }
            } else {
              this.session_reports.avg_session_duration_inc = false;
              if (
                res.data.data.avg_session_duration_seconds == 0 &&
                res.data.data.avg_session_duration_seconds_past != 0
              ) {
                this.session_reports.avg_session_duration_inc_value = "-100.00";
              } else {
                this.session_reports.avg_session_duration_inc_value ="-"+
                  ((
                    (res.data.data.avg_session_duration_seconds_past -
                      res.data.data.avg_session_duration_seconds) /
                    res.data.data.avg_session_duration_seconds_past
                  )* 100).toFixed(2);
              }
            }
          }
        });
    },
    //=============== Get Page Data For PDF =========================//
    async getPageData()
    {
      //==== date range =====//
      let data = {};
      data.start_date = this.date.start ;
      data.end_date = this.date.end ;
      //==== report =====//
      data.quick_report = this.session_reports;
      data.occupancy_report = this.occupancy_chart ;
      data.occupancy_total = this.occupancy_total ;
      data.occupancy_inc = this.occupancy_inc ;
      data.occupancy_inc_percentage = this.occupancy_inc_percentage ;
      console.log('1');
      //========== Earning report ==============//
      if(this.earning == 1)
      {
        let from = null;
        let to = null;
        if (this.chart_type == "hour") {
          this.session_chart_from = this.$moment().format("YYYY-MM-DD");
          this.session_chart_to = this.$moment().format("YYYY-MM-DD");
        } else if (this.chart_type == "day") {
          from = this.date.start;
          to = this.date.end;
        } else if (this.chart_type == "week") {
          from = this.date.start;
          to = this.date.end;
        } else if (this.chart_type == "month") {
          from = this.date.start;
          to = this.date.end;
        } else if (this.chart_type == "year") {
          from = "2018-01-01";
          to = this.date.end;
        } else {
          this.$toasted.show("Something went wrong. Please try again!", {
            icon: "times-circle",
            className: "error-class"
          });
          return false;
        }

        await this.axios
          .post(window.hostname + "api/auth/earning-report", {
            time_zone: this.$moment.tz.guess(new Date()),
            from: from,
            to: to,
            commercial: 1,
            report_type: this.chart_type,
            space_id: this.space_id
          })
          .then(res => {
            if (res.data.status) {
              data.earning_chart = res.data.data.report_data;
              data.earning_total = parseInt(res.data.data.total);
              if (
                this.chart_type == "hour" ||
                this.chart_type == "week" ||
                this.chart_type == "day"
              ) {
                if (
                  parseFloat(res.data.data.total) >=
                  parseFloat(res.data.data.total_prev)
                ) {
                  data.earning_inc = true;
                  if (
                    parseFloat(res.data.data.total) ==
                    parseFloat(res.data.data.total_prev)
                  ) {
                    data.earning_inc_value = "+0.00";
                  } else if (
                    parseFloat(res.data.data.total) != 0 &&
                    parseFloat(res.data.data.total_prev) == 0
                  ) {
                    data.earning_inc_value = "+100.00";
                  } else {
                    data.earning_inc_value =
                      "+" +
                      (
                        (parseFloat(res.data.data.total) -
                          parseFloat(res.data.data.total_prev)) /
                        parseFloat(res.data.data.total_prev)
                      ).toFixed(2) *
                        100;
                  }
                } else {
                  data.earning_inc = false;
                  if (
                    parseFloat(res.data.data.total) == 0 &&
                    parseFloat(res.data.data.total_prev) != 0
                  ) {
                    data.earning_inc_value = "-100.00";
                  } else {
                    data.earning_inc_value =
                      "-" +
                      (
                        (parseFloat(res.data.data.total_prev) -
                          parseFloat(res.data.data.total)) /
                        parseFloat(res.data.data.total_prev)
                      ).toFixed(2) *
                        100;
                  }
                }
              } else {
                let length = data.earning_chart.length - 1;
                let last_value = parseInt(data.earning_chart[length].y);
                let prev_value = parseInt(res.data.data.total_prev);
                if (last_value >= prev_value) {
                  data.earning_inc_value = true;
                  if (prev_value == 0 && last_value != 0) {
                    data.earning_inc_value = "+100.00";
                  } else if (prev_value == last_value) {
                    data.earning_inc_value = "+0.00";
                  } else {
                    data.earning_inc_value =
                      "+" +
                      ((last_value - prev_value) / prev_value).toFixed(2) * 100;
                  }
                } else {
                  data.earning_inc = false;
                  if (prev_value != 0 && last_value == 0) {
                    data.earning_inc_value = "-100.00";
                  } else {
                    data.earning_inc_value =
                      "-" +
                      ((prev_value - last_value) / prev_value).toFixed(2) * 100;
                  }
                }
              }
              console.log('2:1');
              localStorage.setItem("print_data",JSON.stringify(data));
              console.log(JSON.parse(localStorage.getItem("print_data")));
            } else {
              this.$toasted.show("Something went wrong. Please try again!", {
                icon: "times-circle",
                className: "error-class"
              });
            }
          })
          .catch(err => {
            console.log(err);
            this.$toasted.show("Something went wrong. Please try again!", {
              icon: "times-circle",
              className: "error-class"
            });
          });
      }
      else
      {
        data.earning_chart = this.session_chart ;
        data.earning_total = this.session_total ;
        data.earning_inc = this.session_inc ;
        data.earning_inc_value = this.session_inc_value ;
        console.log('2:2');
      }
      // ======= Session report ==============//
      if(this.earning == 2)
      {
        let from = null;
        let to = null;
        if (this.chart_type == "hour") {
          this.session_chart_from = this.$moment().format("YYYY-MM-DD");
          this.session_chart_to = this.$moment().format("YYYY-MM-DD");
        } else if (this.chart_type == "day") {
          from = this.date.start;
          to = this.date.end;
        } else if (this.chart_type == "week") {
          from = this.date.start;
          to = this.date.end;
        } else if (this.chart_type == "month") {
          from = this.date.start;
          to = this.date.end;
        } else if (this.chart_type == "year") {
          from = "2018-01-01";
          to = this.date.end;
        } else {
          this.$toasted.show("Something went wrong. Please try again!", {
            icon: "times-circle",
            className: "error-class"
          });
          return false;
        }

        await this.axios
          .post(window.hostname + "api/auth/session-report", {
            time_zone: this.$moment.tz.guess(new Date()),
            from: from,
            to: to,
            commercial: 1,
            report_type: this.chart_type,
            space_id: this.space_id
          })
          .then(res => {
            if (res.data.status) {
              data.session_chart = res.data.data.report_data;
              data.session_total = parseInt(res.data.data.total);
              if (
                this.chart_type == "hour" ||
                this.chart_type == "week" ||
                this.chart_type == "day"
              ) {
                if (
                  parseFloat(res.data.data.total) >=
                  parseFloat(res.data.data.total_prev)
                ) {
                  data.session_inc = true;
                  if (
                    parseFloat(res.data.data.total) ==
                    parseFloat(res.data.data.total_prev)
                  ) {
                    data.session_inc_value = "+0.00";
                  } else if (
                    parseFloat(res.data.data.total) != 0 &&
                    parseFloat(res.data.data.total_prev) == 0
                  ) {
                    data.session_inc_value = "+100.00";
                  } else {
                    data.session_inc_value =
                      "+" +
                      (
                        (parseFloat(res.data.data.total) -
                          parseFloat(res.data.data.total_prev)) /
                        parseFloat(res.data.data.total_prev)
                      ).toFixed(2) *
                        100;
                  }
                } else {
                  data.session_inc = false;
                  if (
                    parseFloat(res.data.data.total) == 0 &&
                    parseFloat(res.data.data.total_prev) != 0
                  ) {
                    data.session_inc_value = "-100.00";
                  } else {
                    data.session_inc_value =
                      "-" +
                      (
                        (parseFloat(res.data.data.total_prev) -
                          parseFloat(res.data.data.total)) /
                        parseFloat(res.data.data.total_prev)
                      ).toFixed(2) *
                        100;
                  }
                }
              } else {
                let length = data.session_chart.length - 1;
                let last_value = parseInt(data.session_chart[length].y);
                let prev_value = parseInt(res.data.data.total_prev);
                if (last_value >= prev_value) {
                  data.session_inc = true;
                  if (prev_value == 0 && last_value != 0) {
                    data.session_inc_value = "+100.00";
                  } else if (prev_value == last_value) {
                    data.session_inc_value = "+0.00";
                  } else {
                    data.session_inc_value =
                      "+" +
                      ((last_value - prev_value) / prev_value).toFixed(2) * 100;
                  }
                } else {
                  data.session_inc = false;
                  if (prev_value != 0 && last_value == 0) {
                    data.session_inc_value = "-100.00";
                  } else {
                    data.session_inc_value =
                      "-" +
                      ((prev_value - last_value) / prev_value).toFixed(2) * 100;
                  }
                }
              }
              console.log('3:1');
              localStorage.setItem("print_data",JSON.stringify(data));
              console.log(JSON.parse(localStorage.getItem("print_data")));
            } else {
              this.$toasted.show("Something went wrong. Please try again!", {
                icon: "times-circle",
                className: "error-class"
              });
            }
          });
      }
      else
      {
        data.session_chart = this.session_chart ;
        data.session_total = this.session_total ;
        data.session_inc = this.session_inc ;
        data.session_inc_value = this.session_inc_value ;
        console.log('3:2');
        localStorage.setItem("print_data",JSON.stringify(data));
        console.log(JSON.parse(localStorage.getItem("print_data")));
      }
      

      this.$nextTick(()=>{
        this.$router.push({name : "reportPdf"});
      });
    }
  }
};
</script>

<style></style>
